module.exports = __webpack_public_path__ + "static/A-tipo-de-cirurgia-8f5c07bd9735d08247d92e8eaa38b2b4.jpg";